// shadcn/ui component: https://ui.shadcn.com/docs/components/radix/scroll-area
import React from 'react';
import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';

import { cn } from 'src/component/ds/utils';

/* Local change to the shadcn source: Radix wraps the content in a
 * `display: table` div, which lets long text widen it instead of truncating;
 * the Viewport forces it back to block. */
const ScrollArea = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.Root>
>(({ className, children, ...props }, ref) => (
  <ScrollAreaPrimitive.Root
    ref={ref}
    className={cn('ds-relative ds-overflow-hidden', className)}
    {...props}
  >
    <ScrollAreaPrimitive.Viewport className='ds-h-full ds-w-full ds-rounded-[inherit] [&>div]:!ds-block'>
      {children}
    </ScrollAreaPrimitive.Viewport>
    <ScrollBar />
    <ScrollAreaPrimitive.Corner />
  </ScrollAreaPrimitive.Root>
));
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;

const ScrollBar = React.forwardRef<
  React.ElementRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>,
  React.ComponentPropsWithoutRef<typeof ScrollAreaPrimitive.ScrollAreaScrollbar>
>(({ className, orientation = 'vertical', ...props }, ref) => (
  <ScrollAreaPrimitive.ScrollAreaScrollbar
    ref={ref}
    orientation={orientation}
    className={cn(
      'ds-flex ds-touch-none ds-select-none ds-transition-colors',
      orientation === 'vertical' && 'ds-h-full ds-w-2.5 ds-border-l ds-border-l-transparent ds-p-px',
      orientation === 'horizontal' && 'ds-h-2.5 ds-flex-col ds-border-t ds-border-t-transparent ds-p-px',
      className
    )}
    {...props}
  >
    <ScrollAreaPrimitive.ScrollAreaThumb className='ds-relative ds-flex-1 ds-rounded-full ds-bg-border' />
  </ScrollAreaPrimitive.ScrollAreaScrollbar>
));
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;

export { ScrollArea, ScrollBar };
